<template>
  <list-template
    :loading="loading"
    :current-page="page"
    :search-config="searchConfig"
    :table-config="tableConfig"
    :table-data="tableData"
    :total="total"
    hasAdd
    @onAdd="$router.push('./add')"
    @onChangePage="handleCurrentChange"
    @onHandle="tableHandle"
    @onReset="onReset"
    @onSearch="onSearch">
  </list-template>
</template>

<script>
import { tableListMixin } from '@/utils/mixins'

export default {
  _config:{"route":{"path":"list","meta":{"title":"列表","keepAlive":true}}},
  mixins: [tableListMixin],
  data() {
    return {
      tableConfig: [
        { prop: 'goods_name', label: '商品名称' },
        { prop: 'goods_type', label: '收费方式', render: (row) => row.goods_type === 1 ? '一次收费' : '多次收费' },
        { prop: 'is_by_stages_name', label: '是否支持分期' },
        { prop: 'goods_category', label: '商品类型' },
        { prop: 'goods_price', label: '商品价格' },
        { prop: 'creator', label: '创建人' },
        { prop: 'created_at', label: '创建时间' },
        { width: 120, label: '操作', handle: true }
      ],
      searchConfig: [
        { prop: 'goods_name', placeholder: '搜索商品名称' },
        { prop: 'goods_type', tag: 'select', placeholder: '筛选收费方式',
          options: [{label: '一次收费', value: 1}, {label: '多次收费', value: 2 }]
        },
        { prop: 'is_by_stages', tag: 'select', placeholder: '筛选是否支持分期',
          options: [{label: '是', value: 1}, {label: '否', value: 0 }] }
      ]
    }
  },
  methods: {
    getData() {
      this.getDataApi('/zhaosheng/api/recruit/goods-manage/goods-list')
    },

    tableHandle(row, text, index) { // 表格后面操作被点击
      this.$router.push('./edit?id=' + row.id);
    },

  },
};
</script>

<style scoped>
</style>
